// src/features/refilsale/RefillHistory.tsx
import React from 'react';
import { Container, Grid, Button, Paper } from '@mui/material';
import { DownloadForOffline } from '@mui/icons-material';
import axios from 'axios';
import { getToken } from '../../Service/Service';
import { BASE_URL } from '../../common/constant';
import toast from 'react-hot-toast';
import DataGrid from 'components/table/DataGrid';
import { styled } from '@mui/material/styles';

const ContentCard = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    border: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: 'none',
    padding: theme.spacing(2.5),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
    fontWeight: 600,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.2, 3),
}));

interface IRecord {
    id: number;
    recordDate: Date;
    dname: string;
    item: string;
    agent: string;
    quantity: number;
    rate: number;
    totalAmt: number;
    paidCash: number;
    paidOnline: number;
    dueAmt: number;
    remarks: string;
    fare: number;
    totalFare: number;
    finalAmount: number;
    cylinderReceived: number;
    createdAt: Date;
}

const RefillHistory = () => {
    const [history, setHistory] = React.useState<IRecord[]>([]);

    const fetchRefillSale = async () => {
        try {
            const result = await axios.get(BASE_URL + 'refillsale/history', {
                headers: {
                    encryption: false,
                    token: getToken(),
                },
            });
            if (result.data && result.data.result.data) {
                toast.success('Fetched refill sale history successfully');
                setHistory(result.data.result.data);
            }
        } catch (error: any) {
            if (error) {
                console.log('error', error);
                toast.error('Refill sale history fetch failed');
            }
        }
    };

    const columns = [
        { title: 'Record Date', field: 'recordDate', type: 'date', dateSetting: { locale: 'ko-KR' } },
        { title: 'Driver Name', field: 'dname' },
        { title: 'Agent Name', field: 'agent' },
        { title: 'Refil Qnty', field: 'quantity' },
        { title: 'Rate', field: 'rate' },
        { title: 'Total Amount', field: 'totalAmt' },
        { title: 'Due Amount', field: 'dueAmt' },
        { title: 'Fare', field: 'fare' },
        { title: 'Total Fare', field: 'totalFare' },
        { title: 'Paid Cash  Recived', field: 'paidCash' },
        { title: 'Paid Online', field: 'paidOnline' },
        { title: 'Due Amount', field: 'dueAmt' },
        { title: 'Final Amount', field: 'finalAmount' },
        { title: 'Remarks ', field: 'remarks' },
        { title: 'Entry Date ', field: 'createdAt', type: 'date', dateSetting: { locale: 'ko-KR' } },
    ];

    return (
        <>
            <ContentCard>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <StyledButton fullWidth variant="contained" onClick={fetchRefillSale} startIcon={<DownloadForOffline />}>
                            Refill Sale History
                        </StyledButton>
                    </Grid>
                </Grid>
            </ContentCard>
            <Container>
                {history.length > 0 &&
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12}>
                            <DataGrid title="JAMAN HP REFILL SALES" columns={columns} rows={history} />
                        </Grid>
                    </Grid>}
            </Container>
        </>
    );
};

export default RefillHistory;